function parseTalkTimeSeconds(value) {
  if (value == null || value === "") {
    return 0
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    return Math.max(0, Math.floor(value))
  }
  const text = String(value).trim()
  if (!text) {
    return 0
  }
  if (/^\d+$/.test(text)) {
    return Math.max(0, parseInt(text, 10))
  }
  const parts = text.split(":").map((part) => parseInt(part, 10))
  if (parts.some((part) => Number.isNaN(part))) {
    return 0
  }
  if (parts.length === 3) {
    const [hours, minutes, seconds] = parts
    return hours * 3600 + minutes * 60 + seconds
  }
  if (parts.length === 2) {
    const [minutes, seconds] = parts
    return minutes * 60 + seconds
  }
  return 0
}

export function formatTalkTime(value) {
  const totalSeconds = parseTalkTimeSeconds(value)
  if (totalSeconds <= 0) {
    return "0s"
  }
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const parts = []
  if (hours) {
    parts.push(`${hours}h`)
  }
  if (minutes) {
    parts.push(`${minutes}m`)
  }
  if (seconds || !parts.length) {
    parts.push(`${seconds}s`)
  }
  return parts.join(" ")
}
